module.exports = __webpack_public_path__ + "img/layout_right_icon.717a92af.svg";